import { initElement, downloadPDFTable, downloadCSVTable } from 'vlcishared';
import { TEXTS_SEGURIDAD_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';

const FECHA_COLUMN = 'Fecha';
const TIPOLOGIA1 = 'Tipología Nivel 1';
const TIPOLOGIA2 = 'Tipología Nivel 2';
const TIPOLOGIA3 = 'Tipología Nivel 3';
const DISTRITO = 'Distrito';
const BARRIO = 'Barrio';
const NUM_INTERVENCIONES = 'Intervenciones';
let tablePoliciaInstance = null;

function quitarNuloDeDetalleCategoria(detalle) {
  if (!detalle) return '';
  return detalle.replace(/ ?Nulo/i, '').trim();
}

const columnasTabla = [
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_1'),
    field: TIPOLOGIA1,
    width: '20%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_2'),
    field: TIPOLOGIA2,
    width: '20%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_3'),
    field: TIPOLOGIA3,
    width: '20%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('fecha'),
    field: FECHA_COLUMN,
    width: '10%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('distrito'),
    field: DISTRITO,
    width: '10%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('barrio'),
    field: BARRIO,
    width: '10%',
    hozAlign: 'center',
  },
  {
    title: TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('num_intervenciones'),
    field: NUM_INTERVENCIONES,
    width: '10%',
  },
];

export async function tablePolicia(datos) {
  const tableId = 'tablePolicia';

  const nombreFichero = 'Policia.Detalle intervenciones';
  const elementeHTMLCSV = 'download-csv';
  const elementeHTMLPDF = 'download-pdf';

  const dataObj = datos.resultset.map((item) => ({
    [TIPOLOGIA1]: item[0],
    [TIPOLOGIA2]: item[1],
    [TIPOLOGIA3]: quitarNuloDeDetalleCategoria(item[2]),
    [FECHA_COLUMN]: item[3],
    [DISTRITO]: item[4],
    [BARRIO]: item[5],
    [NUM_INTERVENCIONES]: item[6].toString(),
  }));

  const option = {
    height: '100%',
    scrollable: true,
    layout: 'fitColumns',
    columns: columnasTabla,
    pagination: true,
    paginationMode: 'local',
    paginationSize: 10,
    virtualDom: true,
    data: dataObj,
  };


  if (tablePoliciaInstance) {
    tablePoliciaInstance.replaceData(dataObj);
  } else {
    const initializeTable = (table) => {
      tablePoliciaInstance = new Tabulator(table, option);
    };

    await initElement(tableId, initializeTable);
  }

  // Descargar tabla en CSV
  downloadCSVTable(tablePoliciaInstance, nombreFichero, elementeHTMLCSV);

  // Descargar tabla PDF
  downloadPDFTable(tablePoliciaInstance, nombreFichero, elementeHTMLPDF);
}
